import styled from 'styled-components';

export const MobileWrapp = styled.div`
  display: none;

  h1 {
    color: #fff;
    text-align: center;
    width: 80%;
  }
  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
    background-color: #0f1423;
    background-image: url(/static/media/Confetti-Doodles.993ab4c1.svg);
    background-attachment: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
